export const capTableConstants = {
  CAP_TABLE_CREATE_LOADING: 'CAP_TABLE_CREATE_LOADING',
  CAP_TABLE_CREATE_SUCCESS: 'CAP_TABLE_CREATE_SUCCESS',
  CAP_TABLE_CREATE_FAILURE: 'CAP_TABLE_CREATE_FAILURE',
  CAP_TABLE_ERROR_RELOAD: 'CAP_TABLE_ERROR_RELOAD',

  CAP_TABLE_LIST_LOADING: 'CAP_TABLE_LIST_LOADING',
  CAP_TABLE_LIST_SUCCESS: 'CAP_TABLE_LIST_SUCCESS',
  CAP_TABLE_LIST_FAILURE: 'CAP_TABLE_LIST_FAILURE',

  CAP_TABLE_EDIT_LOADING: 'CAP_TABLE_EDIT_LOADING',
  CAP_TABLE_EDIT_SUCCESS: 'CAP_TABLE_EDIT_SUCCESS',
  CAP_TABLE_EDIT_FAILURE: 'CAP_TABLE_EDIT_FAILURE',

  CAP_TABLE_DELETE_LOADING: 'CAP_TABLE_DELETE_LOADING',
  CAP_TABLE_DELETE_SUCCESS: 'CAP_TABLE_DELETE_SUCCESS',
  CAP_TABLE_DELETE_FAILURE: 'CAP_TABLE_DELETE_FAILURE',

  CAP_TABLE_ATTACH_FILE_LOADING: 'CAP_TABLE_ATTACH_FILE_LOADING',
  CAP_TABLE_ATTACH_FILE_SUCCESS: 'CAP_TABLE_ATTACH_FILE_SUCCESS',
  CAP_TABLE_ATTACH_FILE_FAILURE: 'CAP_TABLE_ATTACH_FILE_FAILURE',

  CAP_TABLE_CLONE_LOADING: 'CAP_TABLE_CLONE_LOADING',
  CAP_TABLE_CLONE_SUCCESS: 'CAP_TABLE_CLONE_SUCCESS',
  CAP_TABLE_CLONE_FAILURE: 'CAP_TABLE_CLONE_FAILURE'
};
